import { useEffect, useState } from "react";
import axios from "axios";
import { fetchNearbyOsm } from "@/lib/osm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const haversine = (lat1, lng1, lat2, lng2) => {
  const r = (d) => (d * Math.PI) / 180;
  const a = Math.sin(r(lat2 - lat1) / 2) ** 2 + Math.cos(r(lat1)) * Math.cos(r(lat2)) * Math.sin(r(lng2 - lng1) / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(a));
};

export const useOffices = ([lat, lng]) => {
  const [seed, setSeed] = useState([]);
  const [nearby, setNearby] = useState([]);
  const [loadingNearby, setLoadingNearby] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoadingNearby(true);
    axios.get(`${API}/offices`, { params: { lat, lng } }).then(({ data }) => alive && setSeed(data));
    fetchNearbyOsm(lat, lng)
      .then((items) => alive && setNearby(items.map((o) => ({ ...o, distance_km: haversine(lat, lng, o.lat, o.lng) }))))
      .finally(() => alive && setLoadingNearby(false));
    return () => {
      alive = false;
    };
  }, [lat, lng]);

  const offices = [...seed, ...nearby].sort((a, b) => a.distance_km - b.distance_km);
  return { offices, loadingNearby };
};
